<script>
    import {onMount} from 'svelte';
    import Thumbnail from './Thumbnail.svelte';
    import Marker from './Marker.svelte';
    import {sgettext} from '../../../i18n.js';

    export let id = 'mediaInput';
    export let key = '';
    export let media = null;
    export let width = '160px';
    export let height = '90px';
    export let onChange = () => {};
    export let showLibrary = null;
    export let extraStyle = '';
    export let dropAreaStyle = '';

    let mediaPreviewSrc = '';

    let dragOver = false;

    $: if(media && Object.keys(media).length > 0) {
        mediaPreviewSrc = media.url ? media.url : URL.createObjectURL(media);
    } else if (media instanceof File){
        previewMedia(media);
    } else if (!media || !media.hasOwnProperty('url')) {
        mediaPreviewSrc = '';
    }

    let style = 'min-width: 160px; min-height: 90px;';
    style += extraStyle;

    let fileInput = null;
    let markupMediaModalId = 'markupMediaModal';
    let markupMediaCanvasId = 'markupMediaCanvas';

    function onFileInputChange(event) {
        const files = event.currentTarget.files;
        if(files.length){
            media = files[0];
            handleMediaInputChanged(media);
        }
    }

    function handleMediaInputChanged(media) {
        previewMedia(media);
        onChange(media);
    }

    function getMediaType(media){
        switch(media.type){
            case 'video/mp4':
            case 'VIDEO':
            case 'video':
                return 'VIDEO';
            case 'image/jpeg':
            case 'image/png':
            case 'image/gif':
            case 'IMAGE':
            case 'image':
                return 'IMAGE';
            default:
                return '';
        }
    }

    function handleDragEnter(event) {
        dragOver = true;
    }

    function handleDragLeave(event) {
        dragOver = false;
    }

    function handleDrop(event) {
        dragOver = false;
        const files = event.dataTransfer.files;
        if(files.length){
            media = files[0];
            handleMediaInputChanged(media);
        }
    }

    export function showFileBrowser(){
        fileInput.click();
    }

    function handleBrowseMedia(){
        if(!showLibrary){
            fileInput.click();
        } else {
            showLibrary();
        }
    }

    function handleDragOver(event) {
        // required so that browser will not open the media
        dragOver = true;
    }

    function previewMedia(file) {
        mediaPreviewSrc = URL.createObjectURL(file);
    }


    onMount(() => {
        if(width && height){
            style = `width: ${width}; height: ${height}`;
        }
    });
</script>

<style>
    .hidden {
        display: none;
    }

    .media-uploader {
        background-color: #fff;
        width: 100%;
        position: relative;
        overflow: hidden;
    }

    .drop-area {
        display: flex;
        height: 100%;
        text-align: center;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        font-size: 12px;
        font-weight: bold;
        color: #6c757d;
        border: 1px solid #ced4da;
    }

    .drop-area img {
        width: 100%;
        font-size: 10px;
    }

    .drag-over {
        box-shadow: 0 0 5px rgb(221, 89, 0);
    }

    .placeholder {
        width: 100%;
        /*height: 100%;*/
        display: flex;
        padding: 10px;
        align-items: center;
        justify-content: center;
    }



    .fas:hover {
        opacity: 1;
    }
</style>

<div
    class="media-uploader"
    {style}
    class:drag-over={dragOver}>
    <input
        id={id}
        {key}
        bind:this={fileInput}
        class="hidden"
        type="file"
        accept=".jpg,.jpeg,.png,.gif,.mp4"
        on:change={onFileInputChange} />
    <div
        class="drop-area"
        style={dropAreaStyle}
        on:dragenter|preventDefault|stopPropagation={handleDragEnter}
        on:dragleave|preventDefault|stopPropagation={handleDragLeave}
        on:dragover|preventDefault|stopPropagation={handleDragOver}
        on:drop|preventDefault|stopPropagation={handleDrop}
        on:dragend
        on:dragstart|preventDefault={() => {}}
        >
        {#if mediaPreviewSrc}
            <Thumbnail
                url={mediaPreviewSrc}
                media={mediaPreviewSrc}
                {width}
                {height}
                name={media.name}
                type={getMediaType(media)}/>

        {:else}
        <div on:click={handleBrowseMedia} class="placeholder">
            <div>{sgettext('$$DROP_MEDIA_FILE_CLICK_BROWSE$$')}</div>
        </div>
        {/if}

    </div>

</div>

